/**
 * @flow
 */
'use strict';

export const stereoFlyCodes = [
    {"code":"Normal stereopsis"},
    {"code":"Top of upper wings"},
    {"code":"Bottom of lower wings"},
    {"code":"Tip of abdomen"},
    {"code":"None seen"}
]
